import { useMemo } from 'react';

import { Folder } from '@mui/icons-material';
import {
  Box,
  Stack,
  Typography
} from '@mui/material';
import QRCode from 'react-qr-code';

import imgLogo from 'assets/logo/logoFull.png';
import * as ds from './dataService';


export type FolderQrCodeProps = {
  projectId: string;
  folderId: string;
};

export const FC = ({
  projectId, folderId
}: FolderQrCodeProps) => {
  const urlString = useMemo(() => {
    const { host, protocol } = window.location;
    const sharePath = `/external/${projectId}/folder/${folderId}`;
    const asUrl = new URL(`${protocol}//${host}/auth/register`);
    asUrl.searchParams.set('continue', sharePath);

    return asUrl.toString();
  }, [
    folderId,
    projectId
  ]);

  const {
    formState
  } = ds.useQuery({
    folderId,
    url: urlString
  });

  return (
    <Stack
      gap={2}
      height='100vh'
      justifyContent='space-between'
    >
      <Box sx={{
        textAlign: 'center'
      }}
      >
        <Box
          component='img'
          src={imgLogo}
          sx={{
            maxWidth: '200px'
          }}
        />
      </Box>

      <Stack gap={2}>
        <Stack
          direction='row'
          gap={1}
        >
          <Folder />

          <Typography variant='activityHeader'>
            {formState.folderName}
          </Typography>
        </Stack>

        <Typography>
          {formState.projectName}
        </Typography>

        {urlString && (
          <Box sx={{
            cursor: 'pointer'
          }}
          >
            <QRCode
              value={urlString}
              size={256}
              level='H'
              onClick={() => navigator.clipboard.writeText(urlString)}
            />
          </Box>
        )}

        <Typography sx={{
          maxWidth: 256
        }}
        >
          Please scan and follow prompts to access folder.
        </Typography>
      </Stack>


      <Box />
    </Stack>
  );
};
